export default "__VITE_ASSET__DghAXm4K__"